export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[560px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20modern%20prefabricated%20steel%20frame%20building%20under%20construction%20in%20Taiwan%2C%20precision-engineered%20steel%20beams%20and%20columns%20forming%20a%20large%20residential%20structure%2C%20crane%20lifting%20heavy%20steel%20modules%20against%20clear%20golden%20hour%20sky%2C%20construction%20workers%20in%20professional%20safety%20gear%2C%20organized%20and%20efficient%20construction%20site%2C%20gleaming%20metallic%20steel%20surfaces%2C%20warm%20champagne%20gold%20sunlight%20casting%20long%20dramatic%20shadows%2C%20wide%20angle%20architectural%20photography%2C%20high%20contrast%20clean%20modern%20construction%20atmosphere%2C%20cream%20and%20neutral%20tones%20background&width=1440&height=560&seq=tech-hero-2026&orientation=landscape"
          alt="預製工法優勢 - 鋼構建築"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 container-main h-full flex flex-col justify-center items-center text-center px-4 md:px-8">
        <span className="tag-label bg-white/15 text-cream border-white/20 mb-4">
          TECHNOLOGY COMPARISON
        </span>
        <h1 className="text-cream mb-4 max-w-3xl">
          預製工法 vs 傳統工法
        </h1>
        <p className="text-cream/85 text-base md:text-base max-w-2xl mb-6 leading-relaxed">
          為什麼 Chronos Space 選擇預製鋼構工法？從工期、品質、耐震、節能到碳排放，全方位比較兩種建築方式的差異，讓你做出更明智的決定。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-champagne text-graphite font-semibold text-base hover:bg-champagne/90 transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            預約工法說明會
          </a>
          <a
            href="#comparison"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-cream/40 text-cream font-semibold text-base hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line" />
            </span>
            查看詳細比較
          </a>
        </div>
      </div>
    </section>
  );
}